import type { LoaderData } from '../App/App'

import { Link, useLoaderData } from 'react-router-dom'

import './Nav.css'

export default function Nav () {
  const { doneLoading, allTrackData } = useLoaderData() as LoaderData
  if (!doneLoading) return <></>
  
  // Hard coding Akira the Don
  const artist = 'akira-the-don'
  const { albums } = allTrackData[artist]
  return (
    <div className='nav'>
      <ul>
        {Object.keys(albums).map(album => {
          const { displayName, tracks } = albums[album]
          return (
            <li key={album}>
              {displayName}
              <ul>
                {Object.keys(tracks).map(track => {
                  const { displayName } = tracks[track]
                  const to = `/${artist}/${album}/${track}`
                  return (
                    <li key={track}>
                      <Link to={to}>{displayName}</Link>
                    </li>
                  )
                })}
              </ul>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
